
import React from "react";
import './AdvanceFilter.css';
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { apiurl } from "../../App";
import axiosInstance from "../../api/axiosInstance";
import Grid from "@material-ui/core/Grid";
import Labelbox from "../../helpers/labelbox/labelbox";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}>
      <Typography variant="h6">{children}</Typography>
      <CloseIcon className={`${classes.closeButton} closemodal_icon`} onClick={onClose}
        style={{ left: (localStorage.pharmacy_language == 'ar' ? '3%' : '') }} />
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);
export default class AdvanceFilter extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      resetVal: true,
      prescribed_by: false,
      prescribed_Status: false,
      doctor_list: [],
      status_list: [],
      selected_doctor_id: 0,
      selected_status: 0,
      status_ids: [3, 6, 8]
    }
  }


  componentDidMount() {
    console.log(this.props, '111 props log data');
    this.setState(() => { this.GetDoctorList(); this.GetStatusList() })
  }



  GetDoctorList = () => {
    axiosInstance({
      method: 'post',
      url: apiurl + 'pharmacy/getPharamacyWebFilterDoctors',
      data: {
        "pharmacy_id": localStorage.pharmacy_id ? localStorage.pharmacy_id : 0
      }
    }).then((response) => {
      this.setState({ doctor_list: response.data.data })
    })
  }

  GetStatusList = () => {
    axiosInstance({
      method: 'GET',
      url: apiurl + 'pharmacy/getPharamacyWebFilterStatus'
    }).then((response) => {
      if (this.props.is_show_half_status) {
        let status_list = []
        this.state.status_ids.map((obj) => {
          response.data.data.filter((dataobj) => {
            if (dataobj['pharmacyStatusId'] == obj)
              status_list.push(dataobj)
          })
          console.log(obj)
        })

        this.setState({ status_list })
      }
      else {
        this.setState({ status_list: response.data.data })
      }

    })
  }

  changeDynamic = (data, key) => {
    this.setState({ controlStatement: false, resetVal: false })
    switch (key) {
      case "doctor_id":
        this.setState({ selected_doctor_id: data, prescribed_by: false });
        break
      case "status":
        this.setState({ selected_status: data, prescribed_Status: false });
        break
      default:
        break
    }

  }

  resetFn() {
    setTimeout(() => {
      if (this.state.resetVal) {
        this.setState({ selected_doctor_id: '', selected_status: '', controlStatement: true, prescribed_Status: false, prescribed_by: false })
      }
    }, 1000);
    this.setState({ resetVal: false })
  }
  closeFilterFn() {

    this.props.onClose()
    this.resetFn()
    this.setState({ resetVal: true })
  }
  submitFilter() {

    if (!this.props.is_show_status && this.state.selected_doctor_id != '') {
      this.props.submitAdvanceFilter(this.state.selected_doctor_id)
      this.resetFn()
      this.setState({ resetVal: true })
    }
    else if (this.props.is_show_status && this.state.selected_doctor_id != '' && this.state.selected_status != '') {
      this.props.submitAdvanceFilter(this.state.selected_doctor_id, this.state.selected_status)
      this.resetFn()
      this.setState({ resetVal: true })
    } else if (this.props.is_show_status && this.state.selected_doctor_id == '' && this.state.selected_status == '') {
      this.setState({ prescribed_Status: true, prescribed_by: true });
    } else if (this.props.is_show_status && this.state.selected_doctor_id == '') {
      this.setState({ prescribed_by: true });
    } else if (this.props.is_show_status && this.state.selected_status == '') {
      this.setState({ prescribed_Status: true });
    } else if (!this.props.is_show_status && this.state.selected_doctor_id == '') {
      this.setState({ prescribed_by: true });
    }



    // this.setState({ controlStatement: true })

  }

  render() {
    const { t } = this.props;
    return (
      <Dialog
        className={`Dialogmodal filter_dialogue`}
        // onClose={this.handleClose}
        aria-labelledby="customized-dialog-title"
        open={this.props.open}
        fullWidth={true}
        disableBackdropClick={true}
        maxWidth={"xs"}

      >

        <DialogTitle id="customized-dialog-title" className="modal_head" onClose={() => this.closeFilterFn()}>
          <span className={`${this.props.clrchange} modal_head`}>{t("advance_filter")}</span>
        </DialogTitle>
        <DialogContent dividers className="DialogContent">
          {/* <Grid container spacing={3} className="pl-5 pr-5 pt-2 advance_filter_main_div"
            style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}
          > */}
          <Grid container spacing={3}
            className={` ${this.props.i18n.language == "ar" ? "pl-5 pr-5 pt-2 arabic_cls" : ""
              } pl-5 pr-5 pt-2 advance_filter_main_div`}
            style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}
          >
            <Grid item md={12} sm={12} style={{ paddingBottom: '0px', margin: 'auto' }}>
              <Labelbox
                className="training_adjust"
                labelname={t("prescribed_by")}
                type="select"
                dropdown={this.state.doctor_list}
                valuelabel={"doctor_name"}
                valuebind={"doctor_id"}
                changeData={(data) => this.changeDynamic(data, 'doctor_id')}
                value={this.state.controlStatement ? '' || this.state.controlStatement ? 0 : this.state.selected_doctor_id : this.state.selected_doctor_id}
                error={this.state.prescribed_by}
                // errmsg={"Field required"}
                errmsg={localStorage.pharmacy_language == 'ar' ? "حقل مطلوب" : "Field required"}
                required
              />
            </Grid>

            {this.props.is_show_status && <Grid item md={12} sm={12} style={{ paddingBottom: '0px', margin: 'auto' }}>
              <Labelbox
                className="training_adjust "
                labelname={t("tbl_head_status")}
                type="select"
                dropdown={this.state.status_list}
                valuelabel={"status"}
                valuebind={"pharmacyStatusId"}
                changeData={(data) => this.changeDynamic(data, 'status')}
                value={this.state.controlStatement ? '' || this.state.controlStatement ? 0 : this.state.selected_status : this.state.selected_status}
                error={this.state.prescribed_Status}
                // errmsg={"Field required"}
                errmsg={localStorage.pharmacy_language == 'ar' ? "حقل مطلوب" : "Field required"}
                required
              />
            </Grid>
            }
            <Grid item md={12} sm={12} className=" button_container">
              <Button className="FilterSubmit" onClick={() => { this.submitFilter() }}> {t("submit")} </Button>
            </Grid>

          </Grid>
        </DialogContent>
      </Dialog>
    )

  }
}
